import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import InstallPWA from "./InstallPWA";   // ← Yeh line add karo
import {
  FaPlus,
  FaEdit,
  FaSignOutAlt,
  FaSearch,
  FaBox,
  FaUser,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaSave,
  FaBars,
  FaBuilding,
  FaChevronDown,
  FaCheck,
  FaEllipsisV,
  FaFilter,
  FaTimesCircle,
} from "react-icons/fa";
import api from "../services/api";
import Footer from "./Footer";

// ✅ ComboBox Component
const ComboBox = ({
  label,
  value,
  onChange,
  options = [],
  placeholder,
  required = false,
  icon: Icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState(value || "");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setSearchText(value || "");
  }, [value]);

  useEffect(() => {
    if (searchText) {
      const filtered = options.filter((opt) =>
        opt.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  }, [searchText, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setSearchText(val);
    onChange(val);
    setIsOpen(true);
  };

  const handleSelect = (opt) => {
    setSearchText(opt);
    onChange(opt);
    setIsOpen(false);
  };

  const isNewValue = searchText && !options.includes(searchText);

  return (
    <div style={{ marginBottom: "16px" }} ref={wrapperRef}>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#374151",
          fontSize: "13px",
          fontWeight: "600",
          marginBottom: "6px",
        }}
      >
        {Icon && <Icon size={14} style={{ color: "#6366f1" }} />}
        {label}
        {required && <span style={{ color: "#ef4444" }}>*</span>}
      </label>

      <div style={{ position: "relative" }}>
        <input
          type="text"
          placeholder={placeholder || `Select or type ${label}`}
          value={searchText}
          onChange={handleInputChange}
          onFocus={() => setIsOpen(true)}
          style={{
            width: "100%",
            padding: "10px 36px 10px 12px",
            border: isNewValue ? "2px solid #10b981" : "2px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "14px",
            backgroundColor: "#fff",
            outline: "none",
            transition: "all 0.2s",
            boxSizing: "border-box",
          }}
          // onFocus={(e) => (e.target.style.borderColor = "#6366f1")}
          onBlur={(e) => (e.target.style.borderColor = isNewValue ? "#10b981" : "#d1d5db")}
        />

        <FaChevronDown
          size={12}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: `translateY(-50%) rotate(${isOpen ? "180deg" : "0deg"})`,
            color: "#6b7280",
            transition: "transform 0.2s",
            pointerEvents: "none",
          }}
        />

        {isNewValue && (
          <span
            style={{
              position: "absolute",
              top: "-10px",
              right: "10px",
              background: "#10b981",
              color: "white",
              padding: "2px 8px",
              borderRadius: "6px",
              fontSize: "10px",
              fontWeight: "600",
            }}
          >
            + NEW
          </span>
        )}

        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              background: "white",
              border: "2px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
              maxHeight: "220px",
              overflowY: "auto",
              zIndex: 1000,
              marginTop: "4px",
            }}
          >
            {isNewValue && (
              <div
                onClick={() => handleSelect(searchText)}
                style={{
                  padding: "10px 12px",
                  cursor: "pointer",
                  background: "#ecfdf5",
                  borderBottom: "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#047857",
                  fontSize: "13px",
                  fontWeight: "500",
                }}
              >
                <FaPlus size={11} />
                Add "{searchText}"
              </div>
            )}

            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt, idx) => (
                <div
                  key={idx}
                  onClick={() => handleSelect(opt)}
                  style={{
                    padding: "10px 12px",
                    cursor: "pointer",
                    background: opt === searchText ? "#f3f4f6" : "white",
                    borderBottom: idx < filteredOptions.length - 1 ? "1px solid #f3f4f6" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontSize: "13px",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f9fafb")}
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = opt === searchText ? "#f3f4f6" : "white")
                  }
                >
                  <span style={{ color: "#374151" }}>{opt}</span>
                  {opt === searchText && <FaCheck size={11} style={{ color: "#6366f1" }} />}
                </div>
              ))
            ) : !isNewValue ? (
              <div style={{ padding: "12px", textAlign: "center", color: "#9ca3af", fontSize: "13px" }}>
                No options found
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

// ✅ Main Product Page Component
function ProductPage({ user, onLogout }) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    company: "",
    quality: "",
    minPrice: "",
    maxPrice: "",
  });
  const [showFilters, setShowFilters] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [showActionMenu, setShowActionMenu] = useState(false);
  
  const fileInputRef = useRef(null);
  const actionMenuRef = useRef(null);
  const itemsPerPage = 12;

  const [companyList, setCompanyList] = useState([]);
  const [shortNameList, setShortNameList] = useState([]);
  const [catalogueList, setCatalogueList] = useState([]);
  const [qualityList, setQualityList] = useState([]);

  const [form, setForm] = useState({
    companyName: "",
    shortName: "",
    catalogueName: "",
    qualityName: "",
    designNumber: "",
    rate: 0,
    date: new Date().toISOString().split("T")[0],
    isActive: true,
    createdOn: new Date().toISOString(),
    createdBy: user?.username || "Admin",
    modifiedOn: null,
    modifiedBy: null,
  });

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        setShowActionMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/Product");
      const products = res.data.data || [];
      setData(products);

      const companies = [...new Set(products.map((p) => p.companyName).filter(Boolean))];
      const shortNames = [...new Set(products.map((p) => p.shortName).filter(Boolean))];
      const catalogues = [...new Set(products.map((p) => p.catalogueName).filter(Boolean))];
      const qualities = [...new Set(products.map((p) => p.qualityName).filter(Boolean))];

      setCompanyList(companies.sort());
      setShortNameList(shortNames.sort());
      setCatalogueList(catalogues.sort());
      setQualityList(qualities.sort());
    } catch (err) {
      if (err.response?.status === 401) {
        Swal.fire({
          icon: "warning",
          title: "Session Expired",
          text: "Please login again",
          confirmButtonColor: "#6366f1",
        });
        onLogout();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    const savedLogo = localStorage.getItem("companyLogo");
    if (savedLogo) {
      setCompanyLogo(savedLogo);
    }
  }, []);

  // Filter and search
  const filtered = data.filter((item) => {
    const matchSearch = Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(search.toLowerCase())
    );

    const matchCompany = !filters.company || item.companyName === filters.company;
    const matchQuality = !filters.quality || item.qualityName === filters.quality;
    const matchPrice =
      (!filters.minPrice || item.rate >= parseFloat(filters.minPrice)) &&
      (!filters.maxPrice || item.rate <= parseFloat(filters.maxPrice));

    return matchSearch && matchCompany && matchQuality && matchPrice;
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentData = filtered.slice(indexOfFirst, indexOfLast);

  const resetForm = () => {
    setForm({
      companyName: "",
      shortName: "",
      catalogueName: "",
      qualityName: "",
      designNumber: "",
      rate: 0,
      date: new Date().toISOString().split("T")[0],
      isActive: true,
      createdOn: new Date().toISOString(),
      createdBy: user?.username || "Admin",
      modifiedOn: null,
      modifiedBy: null,
    });
    setEditId(null);
  };

  const handleSave = async () => {
    if (!form.companyName || !form.designNumber) {
      Swal.fire({
        icon: "warning",
        title: "Required Fields!",
        text: "Please fill Company Name and Design Number",
        confirmButtonColor: "#6366f1",
      });
      return;
    }

    try {
      if (editId) {
        await api.put(`/Product/${editId}`, {
          ...form,
          modifiedOn: new Date().toISOString(),
          modifiedBy: user?.username || "Admin",
        });
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Product updated successfully",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        await api.post("/Product", {
          ...form,
          createdBy: user?.username || "Admin",
        });
        Swal.fire({
          icon: "success",
          title: "Added!",
          text: "Product added successfully",
          timer: 1500,
          showConfirmButton: false,
        });
      }
      setShowModal(false);
      resetForm();
      loadData();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Operation failed",
        confirmButtonColor: "#6366f1",
      });
    }
  };

  const handleEdit = (item) => {
    setForm({
      companyName: item.companyName || "",
      shortName: item.shortName || "",
      catalogueName: item.catalogueName || "",
      qualityName: item.qualityName || "",
      designNumber: item.designNumber || "",
      rate: item.rate || 0,
      date: item.date?.split("T")[0] || new Date().toISOString().split("T")[0],
      isActive: item.isActive,
      createdOn: item.createdOn,
      createdBy: item.createdBy,
      modifiedOn: item.modifiedOn,
      modifiedBy: item.modifiedBy,
    });
    setEditId(item.id);
    setShowModal(true);
  };

  const handleUpload = async () => {
    if (!fileInputRef.current?.files?.[0]) {
      Swal.fire({
        icon: "warning",
        title: "No File",
        text: "Please select an Excel file",
        confirmButtonColor: "#6366f1",
      });
      return;
    }

    const file = fileInputRef.current.files[0];
    const formData = new FormData();
    formData.append("file", file);

    setUploading(true);

    try {
      // Get JWT token
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // Add JWT token if exists
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      const response = await api.post("/Product/upload-excel", formData, config);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Excel file uploaded successfully",
        timer: 1500,
        showConfirmButton: false,
      });

      fileInputRef.current.value = "";
      setShowActionMenu(false);
      await loadData();
    } catch (err) {
      console.error("Upload error:", err);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: err.response?.data?.message || "Failed to upload file. Please check file format.",
        confirmButtonColor: "#6366f1",
      });
    } finally {
      setUploading(false);
    }
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#6366f1",
      cancelButtonColor: "#ef4444",
      confirmButtonText: "Yes, Logout",
    }).then((result) => {
      if (result.isConfirmed) {
        onLogout();
      }
    });
  };

  // const handleLogoUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       setCompanyLogo(event.target.result);
  //       localStorage.setItem("companyLogo", event.target.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: "60px",
              height: "60px",
              border: "4px solid rgba(255,255,255,0.3)",
              borderTop: "4px solid white",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          />
          <h4 style={{ color: "white", margin: "0", fontWeight: "600" }}>
            Loading Products...
          </h4>
          <style>{`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "#f9fafb", minHeight: "100vh", paddingBottom: "40px" }}>
      {/* Header */}
      <header
        style={{
          background: "white",
          borderBottom: "1px solid #e5e7eb",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            padding: "16px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Logo & Title */}
          {/* Logo & Title */}
<div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
  <img
    src="/mtlogo.jpg" // <-- logo from public folder
    alt="MT"
    style={{
      height: "40px",
      width: "auto",
      maxWidth: "160px",
      objectFit: "contain",
    }}
  />
  <div>
    <h1
      style={{
        margin: "0",
        fontSize: "20px",
        fontWeight: "700",
        color: "#111827",
      }}
    >
      Products
    </h1>
    <p
      style={{
        margin: "2px 0 0",
        fontSize: "12px",
        color: "#6b7280",
      }}
    >
      {/* Manage MT Price inventory */}
    </p>
  </div>
</div>
          {/* <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {companyLogo ? (
              <img
                src={companyLogo}
                alt="Company Logo"
                style={{
                  height: "40px",
                  width: "auto",
                  maxWidth: "160px",
                  objectFit: "contain",
                }}
              />
            ) : (
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
              >
                P
              </div>
            )}
            <div>
              <h1
                style={{
                  margin: "0",
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#111827",
                }}
              >
                Products
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "12px",
                  color: "#6b7280",
                }}
              >
                Manage MT Price inventory
              </p>
            </div>
          </div> */}

          {/* Action Menu */}
         <div style={{ position: "relative", display: "flex", gap: "12px", alignItems: "center" }} ref={actionMenuRef}>

  {/* Add Product Button */}
  <button
    onClick={() => {
      resetForm();
      setShowModal(true);
    }}
    style={{
      background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
      color: "white",
      border: "none",
      borderRadius: "8px",
      padding: "8px 16px",
      fontWeight: "600",
      cursor: "pointer",
      fontSize: "13px",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      transition: "all 0.2s",
    }}
    onMouseEnter={(e) => {
      e.target.style.transform = "translateY(-2px)";
      e.target.style.boxShadow = "0 8px 16px rgba(99, 102, 241, 0.3)";
    }}
    onMouseLeave={(e) => {
      e.target.style.transform = "translateY(0)";
      e.target.style.boxShadow = "none";
    }}
  >
    <FaPlus size={12} />
    <span style={{ display: "none" }}>Add</span>
  </button>

  {/* Menu Button */}
  <button
    onClick={() => setShowActionMenu(!showActionMenu)}
    style={{
      background: "#f3f4f6",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: "18px",
      color: "#374151",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s",
    }}
    onMouseEnter={(e) => (e.target.style.background = "#e5e7eb")}
    onMouseLeave={(e) => (e.target.style.background = "#f3f4f6")}
  >
    <FaEllipsisV />
  </button>

  {/* Dropdown Menu */}
  {showActionMenu && (
    <div
      style={{
        position: "absolute",
        top: "100%",
        right: "0",
        marginTop: "8px",
        background: "white",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
        minWidth: "240px",
        zIndex: 1000,
      }}
    >
      {/* User Info */}
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #e5e7eb",
          fontSize: "12px",
          color: "#6b7280",
        }}
      >
        <p style={{ margin: "0", fontWeight: "600", color: "#374151" }}>
          {user?.username}
        </p>
        <p style={{ margin: "2px 0 0", fontSize: "11px" }}>Account</p>
      </div>

      {/* ✅ Install App (PWA) - Naya Item */}
      <InstallPWA />

      {/* Upload File */}
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 16px",
          cursor: uploading ? "not-allowed" : "pointer",
          color: uploading ? "#9ca3af" : "#374151",
          fontSize: "13px",
          fontWeight: "500",
          borderBottom: "1px solid #e5e7eb",
          transition: "all 0.2s",
          opacity: uploading ? 0.6 : 1,
        }}
        onMouseEnter={(e) => {
          if (!uploading) e.currentTarget.style.background = "#f3f4f6";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        {uploading ? (
          <>
            <div
              style={{
                width: "12px",
                height: "12px",
                border: "2px solid #e5e7eb",
                borderTop: "2px solid #6366f1",
                borderRadius: "50%",
                animation: "spin 0.8s linear infinite",
              }}
            />
            <span>Uploading...</span>
          </>
        ) : (
          <>
            <span style={{ fontSize: "14px" }}>🆙</span>
            <span>Import Excel File</span>
          </>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx,.xls,.csv"
          onChange={() => {
            if (fileInputRef.current?.files?.[0]) {
              handleUpload();
            }
          }}
          disabled={uploading}
          style={{ display: "none" }}
        />
      </label>

      {/* Logout */}
      <button
        onClick={() => {
          setShowActionMenu(false);
          handleLogout();
        }}
        style={{
          width: "100%",
          padding: "10px 16px",
          background: "transparent",
          border: "none",
          color: "#ef4444",
          fontSize: "13px",
          fontWeight: "500",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          transition: "all 0.2s",
        }}
        onMouseEnter={(e) => (e.target.style.background = "#fee2e2")}
        onMouseLeave={(e) => (e.target.style.background = "transparent")}
      >
        <FaSignOutAlt size={13} />
        <span>Logout</span>
      </button>
    </div>
  )}

  {/* Mobile Menu Button */}
  <button
    onClick={() => setShowMobileMenu(!showMobileMenu)}
    style={{
      background: "transparent",
      border: "none",
      fontSize: "18px",
      color: "#374151",
      cursor: "pointer",
      display: "none",
    }}
  >
    <FaBars />
  </button>
</div>
        </div>

        {/* Mobile Menu */}
        {showMobileMenu && (
          <div
            style={{
              background: "#f9fafb",
              borderTop: "1px solid #e5e7eb",
              padding: "12px 20px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div style={{ fontSize: "13px", color: "#6b7280" }}>
              Logged in as <strong>{user?.username}</strong>
            </div>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 12px",
                cursor: uploading ? "not-allowed" : "pointer",
                color: uploading ? "#9ca3af" : "#374151",
                fontSize: "13px",
                fontWeight: "500",
                background: "#ecfdf5",
                borderRadius: "8px",
                border: "1px solid #d1fae5",
                opacity: uploading ? 0.6 : 1,
              }}
            >
              {uploading ? (
                <>
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      border: "2px solid #d1fae5",
                      borderTop: "2px solid #10b981",
                      borderRadius: "50%",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <span>Uploading...</span>
                </>
              ) : (
                <>
                  <span style={{ fontSize: "14px" }}>📤</span>
                  <span>Import Excel</span>
                </>
              )}
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={() => {
                  if (fileInputRef.current?.files?.[0]) {
                    handleUpload();
                  }
                }}
                disabled={uploading}
                style={{ display: "none" }}
              />
            </label>

            {/* <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 12px",
                cursor: "pointer",
                color: "#374151",
                fontSize: "13px",
                fontWeight: "500",
                background: "#eef2ff",
                borderRadius: "8px",
                border: "1px solid #c7d2fe",
              }}
            >
              <span style={{ fontSize: "14px" }}>🖼️</span>
              <span>Upload Logo</span>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  handleLogoUpload(e);
                  setShowMobileMenu(false);
                }}
                style={{ display: "none" }}
              />
            </label> */}

            <button
              onClick={() => {
                setShowMobileMenu(false);
                handleLogout();
              }}
              style={{
                background: "#ef4444",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "8px 12px",
                fontWeight: "600",
                cursor: "pointer",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
              }}
            >
              <FaSignOutAlt size={12} />
              Logout
            </button>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "24px 20px",
        }}
      >
        {/* Stats Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "16px",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "20px",
              border: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                background: "#ecf0ff",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#6366f1",
                fontSize: "24px",
              }}
            >
              <FaBox />
            </div>
            <div>
              <p style={{ margin: "0", fontSize: "16px", color: "#6e48a8", fontWeight:"bold" }}>
                Total Products
              </p>
              <h3 style={{ margin: "4px 0 0", fontSize: "28px", fontWeight: "700", color: "#111827" }}>
                {data.length}
              </h3>
            </div>
          </div>

          <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "20px",
              border: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                background: "#ecfdf5",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#10b981",
                fontSize: "24px",
              }}
            >
              <FaBuilding />
            </div>
            <div>
              <p style={{ margin: "0", fontSize: "16px", color: "#6e48a8",  fontWeight:"bold"}}>
                Companies
              </p>
              <h3 style={{ margin: "4px 0 0", fontSize: "28px", fontWeight: "700", color: "#111827" }}>
                {companyList.length}
              </h3>
            </div>
          </div>
        </div>

        {/* Search & Filter Bar */}
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "16px",
            border: "1px solid #e5e7eb",
            marginBottom: "24px",
          }}
        >
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "16px" }}>
            {/* Search Input */}
            <div style={{ flex: "1", minWidth: "200px", position: "relative" }}>
              <FaSearch
                size={14}
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#9ca3af",
                }}
              />
              <input
                type="text"
                placeholder="Search products..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                style={{
                  width: "100%",
                  padding: "10px 12px 10px 40px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                  transition: "all 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#6366f1")}
                onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
              />
            </div>

            {/* Filter Toggle Button */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              style={{
                background: showFilters ? "#6366f1" : "#f3f4f6",
                color: showFilters ? "white" : "#374151",
                border: "1px solid" + (showFilters ? "#6366f1" : "#e5e7eb"),
                borderRadius: "8px",
                padding: "10px 16px",
                fontWeight: "600",
                cursor: "pointer",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                transition: "all 0.2s",
              }}
            >
              <FaFilter size={12} />
              Filters
            </button>
          </div>

          {/* Filter Panel */}
          {showFilters && (
            <div
              style={{
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "16px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "12px",
              }}
            >
              {/* Company Filter */}
              <div>
                <label style={{ fontSize: "12px", fontWeight: "600", color: "#374151", display: "block", marginBottom: "6px" }}>
                  Company
                </label>
                <select
                  value={filters.company}
                  onChange={(e) => {
                    setFilters({ ...filters, company: e.target.value });
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "13px",
                    outline: "none",
                  }}
                >
                  <option value="">All Companies</option>
                  {companyList.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>

              {/* Quality Filter */}
              <div>
                <label style={{ fontSize: "12px", fontWeight: "600", color: "#374151", display: "block", marginBottom: "6px" }}>
                  Quality
                </label>
                <select
                  value={filters.quality}
                  onChange={(e) => {
                    setFilters({ ...filters, quality: e.target.value });
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "13px",
                    outline: "none",
                  }}
                >
                  <option value="">All Qualities</option>
                  {qualityList.map((q) => (
                    <option key={q} value={q}>
                      {q}
                    </option>
                  ))}
                </select>
              </div>

              {/* Price Range */}
              <div>
                <label style={{ fontSize: "12px", fontWeight: "600", color: "#374151", display: "block", marginBottom: "6px" }}>
                  Min Price
                </label>
                <input
                  type="number"
                  placeholder="Min"
                  value={filters.minPrice}
                  onChange={(e) => {
                    setFilters({ ...filters, minPrice: e.target.value });
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "13px",
                    outline: "none",
                  }}
                />
              </div>

              <div>
                <label style={{ fontSize: "12px", fontWeight: "600", color: "#374151", display: "block", marginBottom: "6px" }}>
                  Max Price
                </label>
                <input
                  type="number"
                  placeholder="Max"
                  value={filters.maxPrice}
                  onChange={(e) => {
                    setFilters({ ...filters, maxPrice: e.target.value });
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "13px",
                    outline: "none",
                  }}
                />
              </div>

              {/* Clear Filters */}
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                <button
                  onClick={() => {
                    setFilters({ company: "", quality: "", minPrice: "", maxPrice: "" });
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    background: "#f3f4f6",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#374151",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                  }}
                >
                  <FaTimesCircle size={12} />
                  Clear
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Products Grid */}
        {currentData.length > 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            {currentData.map((p) => (
              <div
                key={p.id}
                style={{
                  background: "white",
                  borderRadius: "12px",
                  border: "1px solid #e5e7eb",
                  padding: "16px",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <div style={{ marginBottom: "12px" }}>
                  <h4 style={{ margin: "0 0 4px", fontSize: "15px", fontWeight: "700", color: "#111827" }}>
                    {p.companyName}
                  </h4>
                  <p style={{ margin: "0", fontSize: "12px", color: "#6b7280" }}>
                    {p.shortName || "N/A"}
                  </p>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "12px",
                    marginBottom: "12px",
                    paddingBottom: "12px",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  <div>
                    <p style={{ margin: "0 0 4px", fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                      CATALOGUE
                    </p>
                    <p style={{ margin: "0", fontSize: "13px", fontWeight: "600", color: "#374151" }}>
                      {p.catalogueName || "-"}
                    </p>
                  </div>
                  <div>
                    <p style={{ margin: "0 0 4px", fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                      QUALITY
                    </p>
                    <p style={{ margin: "0", fontSize: "13px", fontWeight: "600", color: "#374151" }}>
                      {p.qualityName || "-"}
                    </p>
                  </div>
                  <div>
                    <p style={{ margin: "0 0 4px", fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                      DESIGN
                    </p>
                    <span
                      style={{
                        display: "inline-block",
                        background: "#f3f4f6",
                        color: "#374151",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {p.designNumber}
                    </span>
                  </div>
                  <div>
                    <p style={{ margin: "0 0 4px", fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                      DATE
                    </p>
                    <p style={{ margin: "0", fontSize: "13px", fontWeight: "600", color: "#374151" }}>
                      {new Date(p.date).toLocaleDateString()}
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      background: "#ecfdf5",
                      color: "#047857",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    ₹{p.rate}
                  </span>
                  <button
                    onClick={() => handleEdit(p)}
                    style={{
                      background: "#f3f4f6",
                      color: "#374151",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontWeight: "600",
                      cursor: "pointer",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#e5e7eb";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "#f3f4f6";
                    }}
                  >
                    <FaEdit size={11} />
                    Edit
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
              padding: "60px 20px",
              textAlign: "center",
            }}
          >
            <FaBox style={{ fontSize: "48px", color: "#d1d5db", marginBottom: "16px" }} />
            <p style={{ color: "#6b7280", margin: "0", fontSize: "14px" }}>
              No products found. Try adjusting your filters or search.
            </p>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "24px",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >
            <p style={{ margin: "0", fontSize: "13px", color: "#6b7280" }}>
              Showing {indexOfFirst + 1}-{Math.min(indexOfLast, filtered.length)} of {filtered.length}
            </p>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                style={{
                  background: currentPage === 1 ? "#f3f4f6" : "white",
                  color: currentPage === 1 ? "#9ca3af" : "#374151",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                <FaChevronLeft size={11} />
              </button>
              <span
                style={{
                  background: "#6366f1",
                  color: "white",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  fontWeight: "600",
                  fontSize: "12px",
                }}
              >
                {currentPage} / {totalPages}
              </span>
              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
                style={{
                  background: currentPage === totalPages ? "#f3f4f6" : "white",
                  color: currentPage === totalPages ? "#9ca3af" : "#374151",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                <FaChevronRight size={11} />
              </button>
            </div>
          </div>
        )}
      </main>

      {/* Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowModal(false);
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              maxWidth: "600px",
              width: "100%",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                color: "white",
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2 style={{ margin: "0", fontSize: "18px", fontWeight: "700" }}>
                {editId ? "✏️ Edit Product" : "➕ Add New Product"}
              </h2>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: "rgba(255,255,255,0.2)",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  width: "32px",
                  height: "32px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                }}
              >
                <FaTimes />
              </button>
            </div>

            <div style={{ padding: "24px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "16px",
                }}
              >
                <div style={{ gridColumn: "1 / -1" }}>
                  <ComboBox
                    label="Company Name"
                    value={form.companyName}
                    onChange={(val) => setForm({ ...form, companyName: val })}
                    options={companyList}
                    placeholder="Select or type company name"
                    required={true}
                    icon={FaBuilding}
                  />
                </div>

                <ComboBox
                  label="Short Name"
                  value={form.shortName}
                  onChange={(val) => setForm({ ...form, shortName: val })}
                  options={shortNameList}
                  placeholder="Select or type short name"
                />

                <ComboBox
                  label="Catalogue Name"
                  value={form.catalogueName}
                  onChange={(val) => setForm({ ...form, catalogueName: val })}
                  options={catalogueList}
                  placeholder="Select or type catalogue"
                />

                <ComboBox
                  label="Quality Name"
                  value={form.qualityName}
                  onChange={(val) => setForm({ ...form, qualityName: val })}
                  options={qualityList}
                  placeholder="Select or type quality"
                />

                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "6px",
                      color: "#374151",
                      fontWeight: "600",
                      fontSize: "13px",
                    }}
                  >
                    Design Number <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter design number"
                    value={form.designNumber}
                    onChange={(e) => setForm({ ...form, designNumber: e.target.value })}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "2px solid #d1d5db",
                      borderRadius: "8px",
                      fontSize: "13px",
                      outline: "none",
                      boxSizing: "border-box",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#6366f1")}
                    onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                  />
                </div>

                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "6px",
                      color: "#374151",
                      fontWeight: "600",
                      fontSize: "13px",
                    }}
                  >
                    Rate (₹)
                  </label>
                  <input
                    type="number"
                    placeholder="0"
                    value={form.rate}
                    onChange={(e) => setForm({ ...form, rate: e.target.value })}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "2px solid #d1d5db",
                      borderRadius: "8px",
                      fontSize: "13px",
                      outline: "none",
                      boxSizing: "border-box",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#6366f1")}
                    onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                  />
                </div>

                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "6px",
                      color: "#374151",
                      fontWeight: "600",
                      fontSize: "13px",
                    }}
                  >
                    Date
                  </label>
                  <input
                    type="date"
                    value={form.date}
                    onChange={(e) => setForm({ ...form, date: e.target.value })}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "2px solid #d1d5db",
                      borderRadius: "8px",
                      fontSize: "13px",
                      outline: "none",
                      boxSizing: "border-box",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#6366f1")}
                    onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                padding: "16px 24px",
                background: "#f9fafb",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                gap: "12px",
                flexDirection: "row-reverse",
              }}
            >
              <button
                onClick={handleSave}
                style={{
                  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontWeight: "600",
                  cursor: "pointer",
                  fontSize: "13px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  flex: 1,
                }}
              >
                <FaSave size={12} />
                {editId ? "Update" : "Save"}
              </button>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: "#f3f4f6",
                  color: "#374151",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontWeight: "600",
                  cursor: "pointer",
                  fontSize: "13px",
                  flex: 1,
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

      <Footer />
    </div>
  );
}

export default ProductPage;




// import React, { useEffect, useState, useRef } from "react";
// import Swal from "sweetalert2";
// import {
//   FaPlus,
//   FaEdit,
//   FaUpload,
//   FaSignOutAlt,
//   FaSearch,
//   FaBox,
//   FaUser,
//   FaChevronLeft,
//   FaChevronRight,
//   FaTimes,
//   FaSave,
//   FaBars,
//   FaBuilding,
//   FaTag,
//   FaChevronDown,
//   FaCheck,
// } from "react-icons/fa";
// import api from "../services/api";
// import Footer from "./Footer"; // ✅ Import Footer

// // ✅ Combobox Component - Dropdown + Input Both Work
// const ComboBox = ({
//   label,
//   value,
//   onChange,
//   options = [],
//   placeholder,
//   required = false,
//   icon: Icon,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchText, setSearchText] = useState(value || "");
//   const [filteredOptions, setFilteredOptions] = useState(options);
//   const wrapperRef = useRef(null);

//   // Update search text when value changes
//   useEffect(() => {
//     setSearchText(value || "");
//   }, [value]);

//   // Filter options based on search
//   useEffect(() => {
//     if (searchText) {
//       const filtered = options.filter((opt) =>
//         opt.toLowerCase().includes(searchText.toLowerCase())
//       );
//       setFilteredOptions(filtered);
//     } else {
//       setFilteredOptions(options);
//     }
//   }, [searchText, options]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Handle input change
//   const handleInputChange = (e) => {
//     const val = e.target.value;
//     setSearchText(val);
//     onChange(val);
//     setIsOpen(true);
//   };

//   // Handle option select
//   const handleSelect = (opt) => {
//     setSearchText(opt);
//     onChange(opt);
//     setIsOpen(false);
//   };

//   // Check if current value exists in options
//   const isNewValue = searchText && !options.includes(searchText);

//   return (
//     <div className="mb-3" ref={wrapperRef}>
//       {/* Label */}
//       <label
//         className="form-label fw-semibold d-flex align-items-center"
//         style={{ color: "#555", fontSize: "14px" }}
//       >
//         {Icon && <Icon className="me-2" style={{ color: "#667eea" }} />}
//         {label}
//         {required && <span style={{ color: "#f5576c", marginLeft: "4px" }}>*</span>}
//       </label>

//       {/* Input with Dropdown */}
//       <div className="position-relative">
//         <div className="input-group">
//           <input
//             type="text"
//             className="form-control"
//             placeholder={placeholder || `Select or type ${label}`}
//             value={searchText}
//             onChange={handleInputChange}
//             onFocus={() => setIsOpen(true)}
//             style={{
//               border: isNewValue ? "2px solid #38ef7d" : "2px solid #e1e5eb",
//               borderRadius: "10px",
//               padding: "12px 45px 12px 15px",
//               fontSize: "14px",
//             }}
//           />
//           <button
//             type="button"
//             className="btn position-absolute"
//             onClick={() => setIsOpen(!isOpen)}
//             style={{
//               right: "5px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               background: "transparent",
//               border: "none",
//               zIndex: 10,
//               padding: "5px 10px",
//             }}
//           >
//             <FaChevronDown
//               style={{
//                 color: "#888",
//                 transition: "transform 0.2s",
//                 transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
//               }}
//             />
//           </button>
//         </div>

//         {/* New Value Badge */}
//         {isNewValue && (
//           <span
//             className="position-absolute"
//             style={{
//               top: "-8px",
//               right: "10px",
//               background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
//               color: "white",
//               padding: "2px 8px",
//               borderRadius: "10px",
//               fontSize: "10px",
//               fontWeight: "600",
//             }}
//           >
//             + NEW
//           </span>
//         )}

//         {/* Dropdown Options */}
//         {isOpen && (
//           <div
//             className="position-absolute w-100 mt-1"
//             style={{
//               background: "white",
//               border: "2px solid #e1e5eb",
//               borderRadius: "10px",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
//               maxHeight: "200px",
//               overflowY: "auto",
//               zIndex: 1000,
//             }}
//           >
//             {/* Show typed value as option if it's new */}
//             {isNewValue && (
//               <div
//                 className="px-3 py-2 d-flex align-items-center"
//                 onClick={() => handleSelect(searchText)}
//                 style={{
//                   cursor: "pointer",
//                   background: "linear-gradient(135deg, #e8fff5 0%, #f0fff4 100%)",
//                   borderBottom: "1px solid #e1e5eb",
//                 }}
//               >
//                 <FaPlus
//                   className="me-2"
//                   style={{ color: "#38ef7d", fontSize: "12px" }}
//                 />
//                 <span style={{ fontWeight: "600", color: "#11998e" }}>
//                   Add "{searchText}"
//                 </span>
//               </div>
//             )}

//             {/* Existing Options */}
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((opt, idx) => (
//                 <div
//                   key={idx}
//                   className="px-3 py-2 d-flex align-items-center justify-content-between"
//                   onClick={() => handleSelect(opt)}
//                   style={{
//                     cursor: "pointer",
//                     background: opt === searchText ? "#f0f4ff" : "white",
//                     borderBottom:
//                       idx < filteredOptions.length - 1 ? "1px solid #f0f0f0" : "none",
//                     transition: "background 0.2s",
//                   }}
//                   onMouseEnter={(e) => (e.target.style.background = "#f8f9ff")}
//                   onMouseLeave={(e) =>
//                     (e.target.style.background = opt === searchText ? "#f0f4ff" : "white")
//                   }
//                 >
//                   <span style={{ color: "#333" }}>{opt}</span>
//                   {opt === searchText && (
//                     <FaCheck style={{ color: "#667eea", fontSize: "12px" }} />
//                   )}
//                 </div>
//               ))
//             ) : !isNewValue ? (
//               <div className="px-3 py-3 text-center" style={{ color: "#999" }}>
//                 No options found
//               </div>
//             ) : null}
//           </div>
//         )}
//       </div>

//       {/* Helper Text */}
//       <small style={{ color: "#888", fontSize: "11px" }}>
//         {options.length > 0
//           ? `${options.length} options available • Type to search or add new`
//           : "Type to add new value"}
//       </small>
//     </div>
//   );
// };

// // ✅ Main Product Page Component
// function ProductPage({ user, onLogout }) {
//   const [data, setData] = useState([]);
//   const [search, setSearch] = useState("");
//   const [file, setFile] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [showMobileMenu, setShowMobileMenu] = useState(false);
//   const itemsPerPage = 8;

//   // Unique lists for dropdowns
//   const [companyList, setCompanyList] = useState([]);
//   const [shortNameList, setShortNameList] = useState([]);
//   const [catalogueList, setCatalogueList] = useState([]);
//   const [qualityList, setQualityList] = useState([]);

//   const [form, setForm] = useState({
//     companyName: "",
//     shortName: "",
//     catalogueName: "",
//     qualityName: "",
//     designNumber: "",
//     rate: 0,
//     date: new Date().toISOString().split("T")[0],
//     isActive: true,
//     createdOn: new Date().toISOString(),
//     createdBy: user?.username || "Admin",
//     modifiedOn: null,
//     modifiedBy: null,
//   });

//   // Load products
//   const loadData = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get("/Product");
//       const products = res.data.data || [];
//       setData(products);

//       // Extract unique values for dropdowns
//       const companies = [...new Set(products.map((p) => p.companyName).filter(Boolean))];
//       const shortNames = [...new Set(products.map((p) => p.shortName).filter(Boolean))];
//       const catalogues = [...new Set(products.map((p) => p.catalogueName).filter(Boolean))];
//       const qualities = [...new Set(products.map((p) => p.qualityName).filter(Boolean))];

//       setCompanyList(companies.sort());
//       setShortNameList(shortNames.sort());
//       setCatalogueList(catalogues.sort());
//       setQualityList(qualities.sort());
//     } catch (err) {
//       if (err.response?.status === 401) {
//         Swal.fire({
//           icon: "warning",
//           title: "Session Expired",
//           text: "Please login again",
//           confirmButtonColor: "#667eea",
//         });
//         onLogout();
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   // Filter
//   const filtered = data.filter((item) =>
//     Object.values(item).some((val) =>
//       val?.toString().toLowerCase().includes(search.toLowerCase())
//     )
//   );

//   // Pagination
//   const totalPages = Math.ceil(filtered.length / itemsPerPage);
//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const currentData = filtered.slice(indexOfFirst, indexOfLast);

//   // Reset form
//   const resetForm = () => {
//     setForm({
//       companyName: "",
//       shortName: "",
//       catalogueName: "",
//       qualityName: "",
//       designNumber: "",
//       rate: 0,
//       date: new Date().toISOString().split("T")[0],
//       isActive: true,
//       createdOn: new Date().toISOString(),
//       createdBy: user?.username || "Admin",
//       modifiedOn: null,
//       modifiedBy: null,
//     });
//     setEditId(null);
//   };

//   // Save
//   const handleSave = async () => {
//     if (!form.companyName || !form.designNumber) {
//       Swal.fire({
//         icon: "warning",
//         title: "Required Fields!",
//         text: "Please fill Company Name and Design Number",
//         confirmButtonColor: "#667eea",
//       });
//       return;
//     }

//     try {
//       if (editId) {
//         await api.put(`/Product/${editId}`, {
//           ...form,
//           modifiedOn: new Date().toISOString(),
//           modifiedBy: user?.username || "Admin",
//         });
//         Swal.fire({
//           icon: "success",
//           title: "Updated!",
//           text: "Product updated successfully",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//       } else {
//         await api.post("/Product", {
//           ...form,
//           createdBy: user?.username || "Admin",
//         });
//         Swal.fire({
//           icon: "success",
//           title: "Added!",
//           text: "Product added successfully",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//       }
//       setShowModal(false);
//       resetForm();
//       loadData();
//     } catch (err) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Operation failed",
//         confirmButtonColor: "#667eea",
//       });
//     }
//   };

//   // Edit
//   const handleEdit = (item) => {
//     setForm({
//       companyName: item.companyName || "",
//       shortName: item.shortName || "",
//       catalogueName: item.catalogueName || "",
//       qualityName: item.qualityName || "",
//       designNumber: item.designNumber || "",
//       rate: item.rate || 0,
//       date: item.date?.split("T")[0] || new Date().toISOString().split("T")[0],
//       isActive: item.isActive,
//       createdOn: item.createdOn,
//       createdBy: item.createdBy,
//       modifiedOn: item.modifiedOn,
//       modifiedBy: item.modifiedBy,
//     });
//     setEditId(item.id);
//     setShowModal(true);
//   };

//   // Upload
//   const handleUpload = async () => {
//     if (!file) {
//       Swal.fire({
//         icon: "warning",
//         title: "No File",
//         text: "Please select an Excel file",
//         confirmButtonColor: "#667eea",
//       });
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       await api.post("/Product/upload-excel", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       Swal.fire({
//         icon: "success",
//         title: "Uploaded!",
//         text: "Excel file uploaded successfully",
//         timer: 1500,
//         showConfirmButton: false,
//       });
//       setFile(null);
//       loadData();
//     } catch (err) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Upload failed",
//         confirmButtonColor: "#667eea",
//       });
//     }
//   };

//   // Logout
//   const handleLogout = () => {
//     Swal.fire({
//       title: "Logout?",
//       text: "Are you sure you want to logout?",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonColor: "#667eea",
//       cancelButtonColor: "#dc3545",
//       confirmButtonText: "Yes, Logout",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         onLogout();
//       }
//     });
//   };

//   // Loading
//   if (loading) {
//     return (
//       <div
//         className="min-vh-100 d-flex align-items-center justify-content-center"
//         style={{ background: "#f5f7fa" }}
//       >
//         <div className="text-center">
//           <div
//             className="spinner-border mb-3"
//             style={{ width: "3rem", height: "3rem", color: "#667eea" }}
//           ></div>
//           <h5 style={{ color: "#667eea" }}>Loading Products...</h5>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{ background: "#f5f7fa", minHeight: "100vh" }}>
//       {/* Navbar */}
//       <nav
//         style={{
//           background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//           boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
//           padding: "12px 20px",
//         }}
//       >
//         <div className="d-flex justify-content-between align-items-center">
//           {/* Logo */}
//           <div className="d-flex align-items-center">
//             <FaBox style={{ fontSize: "24px", color: "white", marginRight: "10px" }} />
//             <h5 className="mb-0 text-white fw-bold d-none d-sm-block">
//               Product Dashboard
//             </h5>
//             <h5 className="mb-0 text-white fw-bold d-sm-none">Products</h5>
//           </div>

//           {/* Desktop Menu */}
//           <div className="d-none d-md-flex align-items-center gap-3">
//             <div
//               className="d-flex align-items-center px-3 py-2"
//               style={{
//                 background: "rgba(255,255,255,0.2)",
//                 borderRadius: "25px",
//               }}
//             >
//               <FaUser style={{ color: "white", marginRight: "8px" }} />
//               <span style={{ color: "white", fontWeight: "500" }}>
//                 {user?.username}
//               </span>
//             </div>
//             <button
//               className="btn"
//               onClick={handleLogout}
//               style={{
//                 background: "rgba(255,255,255,0.2)",
//                 color: "white",
//                 border: "2px solid rgba(255,255,255,0.3)",
//                 borderRadius: "25px",
//                 padding: "8px 20px",
//                 fontWeight: "600",
//               }}
//             >
//               <FaSignOutAlt className="me-2" />
//               Logout
//             </button>
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             className="btn d-md-none"
//             onClick={() => setShowMobileMenu(!showMobileMenu)}
//             style={{
//               background: "rgba(255,255,255,0.2)",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               padding: "8px 12px",
//             }}
//           >
//             <FaBars />
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {showMobileMenu && (
//           <div
//             className="d-md-none mt-3 p-3"
//             style={{
//               background: "rgba(255,255,255,0.1)",
//               borderRadius: "10px",
//             }}
//           >
//             <div className="d-flex align-items-center mb-2">
//               <FaUser style={{ color: "white", marginRight: "10px" }} />
//               <span style={{ color: "white" }}>{user?.username}</span>
//             </div>
//             <button
//               className="btn w-100"
//               onClick={handleLogout}
//               style={{
//                 background: "rgba(255,255,255,0.2)",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "8px",
//               }}
//             >
//               <FaSignOutAlt className="me-2" />
//               Logout
//             </button>
//           </div>
//         )}
//       </nav>

//       {/* Main Content */}
//       <div className="p-3 p-md-4">
//         {/* Stats */}
//         <div className="row mb-3">
//           <div className="col-6 col-md-3 mb-3">
//             <div
//               className="card border-0 h-100"
//               style={{
//                 borderRadius: "15px",
//                 boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
//               }}
//             >
//               <div className="card-body d-flex align-items-center p-3">
//                 <div
//                   className="me-3"
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     borderRadius: "12px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <FaBox style={{ color: "white", fontSize: "20px" }} />
//                 </div>
//                 <div>
//                   <h4 className="mb-0 fw-bold">{data.length}</h4>
//                   <small style={{ color: "#888" }}>Products</small>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-6 col-md-3 mb-3">
//             <div
//               className="card border-0 h-100"
//               style={{
//                 borderRadius: "15px",
//                 boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
//               }}
//             >
//               <div className="card-body d-flex align-items-center p-3">
//                 <div
//                   className="me-3"
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
//                     borderRadius: "12px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <FaBuilding style={{ color: "white", fontSize: "20px" }} />
//                 </div>
//                 <div>
//                   <h4 className="mb-0 fw-bold">{companyList.length}</h4>
//                   <small style={{ color: "#888" }}>Companies</small>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Search & Actions */}
//         <div
//           className="card border-0 mb-3"
//           style={{
//             borderRadius: "15px",
//             boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
//           }}
//         >
//           <div className="card-body p-3">
//             <div className="row g-2 g-md-3">
//               {/* Search */}
//               <div className="col-12 col-md-4">
//                 <div className="input-group">
//                   <span
//                     className="input-group-text"
//                     style={{
//                       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                       border: "none",
//                       color: "white",
//                       borderRadius: "10px 0 0 10px",
//                     }}
//                   >
//                     <FaSearch />
//                   </span>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search products..."
//                     value={search}
//                     onChange={(e) => {
//                       setSearch(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                     style={{
//                       border: "2px solid #e1e5eb",
//                       borderLeft: "none",
//                       borderRadius: "0 10px 10px 0",
//                     }}
//                   />
//                 </div>
//               </div>

//               {/* Upload */}
//               <div className="col-12 col-md-5">
//                 <div className="d-flex gap-2">
//                   <input
//                     type="file"
//                     accept=".xlsx,.xls"
//                     className="form-control"
//                     onChange={(e) => setFile(e.target.files[0])}
//                     style={{
//                       border: "2px solid #e1e5eb",
//                       borderRadius: "10px",
//                     }}
//                   />
//                   <button
//                     className="btn px-3"
//                     onClick={handleUpload}
//                     style={{
//                       background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "10px",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     <FaUpload className="me-1" />
//                     <span className="d-none d-sm-inline">Upload</span>
//                   </button>
//                 </div>
//               </div>

//               {/* Add Button */}
//               <div className="col-12 col-md-3">
//                 <button
//                   className="btn w-100"
//                   onClick={() => {
//                     resetForm();
//                     setShowModal(true);
//                   }}
//                   style={{
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "10px",
//                     padding: "10px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   <FaPlus className="me-2" />
//                   Add Product
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Desktop Table */}
//         <div className="d-none d-md-block">
//           <div
//             className="card border-0"
//             style={{
//               borderRadius: "15px",
//               boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
//               overflow: "hidden",
//             }}
//           >
//             <div className="table-responsive">
//               <table className="table table-hover align-middle mb-0">
//                 <thead>
//                   <tr
//                     style={{
//                       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     }}
//                   >
//                     <th style={{ color: "white", padding: "15px" }}>Company</th>
//                     <th style={{ color: "white", padding: "15px" }}>Short Name</th>
//                     <th style={{ color: "white", padding: "15px" }}>Catalogue</th>
//                     <th style={{ color: "white", padding: "15px" }}>Quality</th>
//                     <th style={{ color: "white", padding: "15px" }}>Design</th>
//                     <th style={{ color: "white", padding: "15px" }}>Date</th>
//                     <th style={{ color: "white", padding: "15px" }}>Rate</th>
//                     <th style={{ color: "white", padding: "15px", textAlign: "center" }}>
//                       Action
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentData.length > 0 ? (
//                     currentData.map((p, index) => (
//                       <tr
//                         key={p.id}
//                         style={{ background: index % 2 === 0 ? "#fff" : "#f8f9ff" }}
//                       >
//                         <td style={{ padding: "12px 15px", fontWeight: "500" }}>
//                           {p.companyName}
//                         </td>
//                         <td style={{ padding: "12px 15px", color: "#666" }}>
//                           {p.shortName}
//                         </td>
//                         <td style={{ padding: "12px 15px", color: "#666" }}>
//                           {p.catalogueName}
//                         </td>
//                         <td style={{ padding: "12px 15px", color: "#666" }}>
//                           {p.qualityName}
//                         </td>
//                         <td style={{ padding: "12px 15px" }}>
//                           <span
//                             style={{
//                               background: "#e8f4fd",
//                               color: "#2196f3",
//                               padding: "4px 10px",
//                               borderRadius: "15px",
//                               fontSize: "12px",
//                               fontWeight: "600",
//                             }}
//                           >
//                             {p.designNumber}
//                           </span>
//                         </td>
//                         <td style={{ padding: "12px 15px", color: "#666", fontSize: "13px" }}>
//                           {new Date(p.date).toLocaleDateString()}
//                         </td>
//                         <td style={{ padding: "12px 15px" }}>
//                           <span
//                             style={{
//                               background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
//                               color: "white",
//                               padding: "5px 12px",
//                               borderRadius: "15px",
//                               fontSize: "13px",
//                               fontWeight: "600",
//                             }}
//                           >
//                             ₹{p.rate}
//                           </span>
//                         </td>
//                         <td style={{ padding: "12px 15px", textAlign: "center" }}>
//                           <button
//                             className="btn btn-sm"
//                             onClick={() => handleEdit(p)}
//                             style={{
//                               background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//                               color: "white",
//                               border: "none",
//                               borderRadius: "8px",
//                               padding: "6px 15px",
//                             }}
//                           >
//                             <FaEdit className="me-1" /> Edit
//                           </button>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="8" className="text-center py-5">
//                         <FaBox style={{ fontSize: "50px", color: "#ddd" }} />
//                         <p className="text-muted mt-2 mb-0">No products found</p>
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Cards */}
//         <div className="d-md-none">
//           {currentData.length > 0 ? (
//             currentData.map((p) => (
//               <div
//                 key={p.id}
//                 className="card border-0 mb-3"
//                 style={{
//                   borderRadius: "15px",
//                   boxShadow: "0 3px 15px rgba(0,0,0,0.08)",
//                 }}
//               >
//                 <div className="card-body p-3">
//                   <div className="d-flex justify-content-between align-items-start mb-3">
//                     <div>
//                       <h6 className="mb-1 fw-bold">{p.companyName}</h6>
//                       <small style={{ color: "#888" }}>{p.shortName}</small>
//                     </div>
//                     <span
//                       style={{
//                         background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
//                         color: "white",
//                         padding: "5px 12px",
//                         borderRadius: "20px",
//                         fontSize: "14px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       ₹{p.rate}
//                     </span>
//                   </div>

//                   <div className="row g-2 mb-3">
//                     <div className="col-6">
//                       <small style={{ color: "#888" }}>Catalogue</small>
//                       <p className="mb-0 fw-medium" style={{ fontSize: "14px" }}>
//                         {p.catalogueName || "-"}
//                       </p>
//                     </div>
//                     <div className="col-6">
//                       <small style={{ color: "#888" }}>Quality</small>
//                       <p className="mb-0 fw-medium" style={{ fontSize: "14px" }}>
//                         {p.qualityName || "-"}
//                       </p>
//                     </div>
//                     <div className="col-6">
//                       <small style={{ color: "#888" }}>Design</small>
//                       <p className="mb-0">
//                         <span
//                           style={{
//                             background: "#e8f4fd",
//                             color: "#2196f3",
//                             padding: "2px 8px",
//                             borderRadius: "10px",
//                             fontSize: "12px",
//                           }}
//                         >
//                           {p.designNumber}
//                         </span>
//                       </p>
//                     </div>
//                     <div className="col-6">
//                       <small style={{ color: "#888" }}>Date</small>
//                       <p className="mb-0" style={{ fontSize: "14px" }}>
//                         {new Date(p.date).toLocaleDateString()}
//                       </p>
//                     </div>
//                   </div>

//                   <button
//                     className="btn w-100"
//                     onClick={() => handleEdit(p)}
//                     style={{
//                       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "10px",
//                       padding: "10px",
//                     }}
//                   >
//                     <FaEdit className="me-2" />
//                     Edit Product
//                   </button>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="text-center py-5">
//               <FaBox style={{ fontSize: "50px", color: "#ddd" }} />
//               <p className="text-muted mt-3">No products found</p>
//             </div>
//           )}
//         </div>

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 mt-4">
//             <small style={{ color: "#666" }}>
//               Showing {indexOfFirst + 1}-{Math.min(indexOfLast, filtered.length)} of{" "}
//               {filtered.length}
//             </small>
//             <div className="d-flex gap-2">
//               <button
//                 className="btn"
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage(currentPage - 1)}
//                 style={{
//                   background:
//                     currentPage === 1
//                       ? "#e1e5eb"
//                       : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                   color: currentPage === 1 ? "#999" : "white",
//                   border: "none",
//                   borderRadius: "8px",
//                   padding: "8px 15px",
//                 }}
//               >
//                 <FaChevronLeft />
//               </button>
//               <span
//                 style={{
//                   background: "#667eea",
//                   color: "white",
//                   padding: "8px 15px",
//                   borderRadius: "8px",
//                   fontWeight: "600",
//                 }}
//               >
//                 {currentPage}/{totalPages}
//               </span>
//               <button
//                 className="btn"
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage(currentPage + 1)}
//                 style={{
//                   background:
//                     currentPage === totalPages
//                       ? "#e1e5eb"
//                       : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                   color: currentPage === totalPages ? "#999" : "white",
//                   border: "none",
//                   borderRadius: "8px",
//                   padding: "8px 15px",
//                 }}
//               >
//                 <FaChevronRight />
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ✅ Add/Edit Modal with ComboBox */}
//       {showModal && (
//         <div
//           className="modal show d-block"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//           onClick={(e) => {
//             if (e.target === e.currentTarget) setShowModal(false);
//           }}
//         >
//           <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable mx-2 mx-md-auto">
//             <div
//               className="modal-content border-0"
//               style={{ borderRadius: "20px", overflow: "hidden" }}
//             >
//               {/* Header */}
//               <div
//                 className="modal-header border-0 py-3"
//                 style={{
//                   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 }}
//               >
//                 <h5 className="modal-title text-white fw-bold">
//                   {editId ? "✏️ Edit Product" : "➕ Add New Product"}
//                 </h5>
//                 <button
//                   className="btn p-0"
//                   onClick={() => setShowModal(false)}
//                   style={{
//                     background: "rgba(255,255,255,0.2)",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "50%",
//                     width: "35px",
//                     height: "35px",
//                   }}
//                 >
//                   <FaTimes />
//                 </button>
//               </div>

//               {/* Body */}
//               <div className="modal-body p-3 p-md-4">
//                 <div className="row">
//                   {/* Company Name - ComboBox */}
//                   <div className="col-12 col-md-6">
//                     <ComboBox
//                       label="Company Name"
//                       value={form.companyName}
//                       onChange={(val) => setForm({ ...form, companyName: val })}
//                       options={companyList}
//                       placeholder="Select or type company name"
//                       required={true}
//                       icon={FaBuilding}
//                     />
//                   </div>

//                   {/* Short Name - ComboBox */}
//                   <div className="col-12 col-md-6">
//                     <ComboBox
//                       label="Short Name"
//                       value={form.shortName}
//                       onChange={(val) => setForm({ ...form, shortName: val })}
//                       options={shortNameList}
//                       placeholder="Select or type short name"
//                       icon={FaTag}
//                     />
//                   </div>

//                   {/* Catalogue Name - ComboBox */}
//                   <div className="col-12 col-md-6">
//                     <ComboBox
//                       label="Catalogue Name"
//                       value={form.catalogueName}
//                       onChange={(val) => setForm({ ...form, catalogueName: val })}
//                       options={catalogueList}
//                       placeholder="Select or type catalogue"
//                     />
//                   </div>

//                   {/* Quality Name - ComboBox */}
//                   <div className="col-12 col-md-6">
//                     <ComboBox
//                       label="Quality Name"
//                       value={form.qualityName}
//                       onChange={(val) => setForm({ ...form, qualityName: val })}
//                       options={qualityList}
//                       placeholder="Select or type quality"
//                     />
//                   </div>

//                   {/* Design Number - Regular Input */}
//                   <div className="col-12 col-md-6">
//                     <div className="mb-3">
//                       <label
//                         className="form-label fw-semibold"
//                         style={{ color: "#555", fontSize: "14px" }}
//                       >
//                         Design Number <span style={{ color: "#f5576c" }}>*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter design number"
//                         value={form.designNumber}
//                         onChange={(e) =>
//                           setForm({ ...form, designNumber: e.target.value })
//                         }
//                         style={{
//                           border: "2px solid #e1e5eb",
//                           borderRadius: "10px",
//                           padding: "12px 15px",
//                         }}
//                       />
//                     </div>
//                   </div>

//                   {/* Rate */}
//                   <div className="col-6 col-md-3">
//                     <div className="mb-3">
//                       <label
//                         className="form-label fw-semibold"
//                         style={{ color: "#555", fontSize: "14px" }}
//                       >
//                         Rate (₹)
//                       </label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         placeholder="0"
//                         value={form.rate}
//                         onChange={(e) => setForm({ ...form, rate: e.target.value })}
//                         style={{
//                           border: "2px solid #e1e5eb",
//                           borderRadius: "10px",
//                           padding: "12px 15px",
//                         }}
//                       />
//                     </div>
//                   </div>

//                   {/* Date */}
//                   <div className="col-6 col-md-3">
//                     <div className="mb-3">
//                       <label
//                         className="form-label fw-semibold"
//                         style={{ color: "#555", fontSize: "14px" }}
//                       >
//                         Date
//                       </label>
//                       <input
//                         type="date"
//                         className="form-control"
//                         value={form.date}
//                         onChange={(e) => setForm({ ...form, date: e.target.value })}
//                         style={{
//                           border: "2px solid #e1e5eb",
//                           borderRadius: "10px",
//                           padding: "12px 15px",
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Info Box */}
//                 <div
//                   className="mt-2 p-3"
//                   style={{
//                     background: "#f0f4ff",
//                     borderRadius: "10px",
//                     border: "1px solid #667eea",
//                   }}
//                 >
//                   <small style={{ color: "#667eea" }}>
//                     💡 <strong>Tip:</strong> You can either select from dropdown or type a new value.
//                     New values will show a green{" "}
//                     <span
//                       style={{
//                         background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
//                         color: "white",
//                         padding: "1px 6px",
//                         borderRadius: "8px",
//                         fontSize: "10px",
//                       }}
//                     >
//                       + NEW
//                     </span>{" "}
//                     badge.
//                   </small>
//                 </div>
//               </div>

//               {/* Footer */}
//               <div
//                 className="modal-footer border-0 p-3 p-md-4 flex-column flex-sm-row gap-2"
//                 style={{ background: "#f8f9ff" }}
//               >
//                 <button
//                   className="btn px-4 py-2 w-100 w-sm-auto order-2 order-sm-1"
//                   onClick={() => setShowModal(false)}
//                   style={{
//                     background: "#e1e5eb",
//                     color: "#666",
//                     border: "none",
//                     borderRadius: "10px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   <FaTimes className="me-2" />
//                   Cancel
//                 </button>
//                 <button
//                   className="btn px-4 py-2 w-100 w-sm-auto order-1 order-sm-2"
//                   onClick={handleSave}
//                   style={{
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "10px",
//                     fontWeight: "600",
//                     boxShadow: "0 5px 15px rgba(102, 126, 234, 0.4)",
//                   }}
//                 >
//                   <FaSave className="me-2" />
//                   {editId ? "Update Product" : "Save Product"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//        <Footer />
//     </div>
//   );
// }

// export default ProductPage;